import { ApplicationRef, enableProdMode, isDevMode, NgModuleRef, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { environment } from '@env';

import { AppModule } from './app/app.module';

function enableDebugTools(moduleRef: NgModuleRef<AppModule>): void {
  import('@angular/platform-browser').then(platformBrowser => {
    const applicationRef = moduleRef.injector.get(ApplicationRef);
    const componentRef = applicationRef.components[0];
    platformBrowser.enableDebugTools(componentRef);
  });
}

if (environment.production) {
  enableProdMode();
}

platformBrowser()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .then((moduleRef: NgModuleRef<AppModule>) => {
    if (isDevMode()) {
      enableDebugTools(moduleRef);
    }
  })
  .catch(err => console.log(err));
